module.exports = __webpack_public_path__ + "img/add-circle.2addc6f6.svg";